import React from 'react';
import {
  BuildingConstruction,
  BuildingConstructionDetails,
  ConstructionEquipment,
  EnergyConsumption,
  EnergyEfficiency,
  EnergyEfficiencyDetails,
  LandUseChange,
  MeasurementSystem,
  RawMaterialUse,
  RoadMaintenance,
  RoadPavement,
  Streetlights,
  UrbanContextType,
} from '../../../../../../services/types/Calculator';

const emptyLandUseChange: LandUseChange = {
  moduleId: 0,
  name: '',
  coversType: [],
  rows: [],
  subTotal: null,
  infoUrl: null,
};

const emptyRawMaterialUse: RawMaterialUse = {
  moduleId: 0,
  name: '',
  rawMaterials: [],
  rows: [],
  subTotal: null,
};

const emptyStreetlights: Streetlights = {
  moduleId: 0,
  name: '',
  defaultFactorValue: 0,
  subTotal: null,
  numberOfBulbs: null,
  hoursDay: null,
  wattage: null,
  customEmissionFactor: null,
  isCustomFactor: false,
};

const emptyRoadPavement: RoadPavement = {
  moduleId: 0,
  name: '',
  factorValue: 0,
  factorWidth: 0,
  sqFeetToSqMeters: 0,
  sqDefaultEmission: 0,
  isTotalAreaKnown: null,
  totalArea: null,
  pavedRoadLength: null,
  numberOfLanes: null,
  subTotal: null,
  pavedRoadArea: null,
  totalAreaRoadRehabilitated: null,
};

const emptyRoadMaintenance: RoadMaintenance = {
  moduleId: 0,
  name: '',
  factorValue: 0,
  subTotal: null,
  area: null,
  isCustomArea: false,
  areaFromPavement: null,
};

const emptBuildingConstructionDetails: BuildingConstructionDetails = {
  id: 0,
  name: '',
  defaultFactor: 0,
  defaultArea: null,
  emissions: null,
  avgMaterial: 0,
};

const emptyBuildingConstruction: BuildingConstruction = {
  moduleId: 0,
  name: '',
  subTotal: null,
  isEstimated: null,
  totalArea: null,
  buildingsType: [],
  columns: emptBuildingConstructionDetails,
  floors: emptBuildingConstructionDetails,
  exteriorWalls: emptBuildingConstructionDetails,
  windows: emptBuildingConstructionDetails,
  interiorWalls: emptBuildingConstructionDetails,
  roofs: emptBuildingConstructionDetails,
  rows: [],
};

const emptyEnergyEfficiencyDetails: EnergyEfficiencyDetails = {
  kwhBefore: 0,
  kwhAfter: 0,
  totalSaving: 0,
  avoidedEmissions: 0,
};

const emptyEnergyEfficiency: EnergyEfficiency = {
  moduleId: 0,
  name: '',
  unitsReplaced: null,
  wattageConventional: null,
  hoursDay: null,
  subTotal: null,
  factors: [],
  customWattageReplacement: null,
  isCustomWattage: false,
  countryFactor: 0,
  details: emptyEnergyEfficiencyDetails,
  defaultInputValue: null,
  defaultUnit: null,
};

const emptyConstructionEquipment: ConstructionEquipment = {
  moduleId: 0,
  name: '',
  isFuelData: null,
  fuelDataFactors: [],
  fuelDataRows: [],
  subTotal: null,
  vehicleFactors: [],
  vehicleDataRows: [],
  co2Total: null,
  ch4Total: null,
  n2OTotal: null,
};

const emptyEnergyConsumption: EnergyConsumption = {
  moduleId: 0,
  name: '',
  energyTypes: [],
  rows: [],
  subTotal: null,
  co2Total: null,
  ch4Total: null,
  n2OTotal: null,
  constructionTypes: [],
  functionTypes: [],
  eletricityRows: [],
  eletricityRowsTotal: null,
};

const emptyMeasurementSystem: MeasurementSystem = {
  id: 1,
  name: 'Metric',
};

const Context = React.createContext<UrbanContextType>({
  calculateId: null,
  operationId: null,
  country: null,
  sector: null,
  measurementSystem: emptyMeasurementSystem,
  landUseChange: emptyLandUseChange,
  rawMaterialUse: emptyRawMaterialUse,
  streetlights: emptyStreetlights,
  roadPavement: emptyRoadPavement,
  constructionEquipment: emptyConstructionEquipment,
  roadMaintenance: emptyRoadMaintenance,
  energyEfficiency: emptyEnergyEfficiency,
  buildingConstruction: emptyBuildingConstruction,
  energyConsumptionConstruction: emptyEnergyConsumption,
  energyConsumptionOperation: emptyEnergyConsumption,
  totalConstructionOverriden: null,
  totalOperationOverriden: null,
  reload: () => {},
  isFinished: false,
});

export default Context;
